import type React from 'react';
import { useEffect } from 'react';

import { OnboardingProgressStep, useProgress } from '@/context/progress';
import BaseLayout from '@/layouts/base';

const AmlQuestionnaireLayout = (props: React.ComponentPropsWithoutRef<typeof BaseLayout>) => {
  const { setCurrentStep } = useProgress();

  useEffect(() => {
    return setCurrentStep(OnboardingProgressStep.PERSONAL_TRADING_INFORMATION);
  }, [setCurrentStep]);

  return <BaseLayout {...props} />;
};
AmlQuestionnaireLayout.displayName = 'AmlQuestionnaireLayout';

export default AmlQuestionnaireLayout;
